import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const TablePT = ({ registrosPT = [], EliminarPT }) => {
    return (
        <div className="new-table-wrapper listado-pt__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Acciones</th>
                        <th>Tipo de producto</th>
                        <th>Producto</th>
                        <th>Padre</th>
                        <th>Código</th>
                    </tr>
                </thead>
                <tbody>
                    {registrosPT.length === 0 && (
                        <tr>
                            <td colSpan={5} className="text-center">
                                No hay registros de productos terminados
                            </td>
                        </tr>
                    )}
                    {registrosPT.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <div className="table-actions">
                                        <Link
                                            to={`/producto-terminado/${item.id}/editar`}
                                        >
                                            <img
                                                src={editarIcon}
                                                alt="Editar"
                                                className="action_img"
                                                title="Editar"
                                            />
                                        </Link>
                                        <img
                                            src={eliminarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() => EliminarPT(item.id)}
                                        />
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.tipo_materia_prima
                                        ? item.tipo_materia_prima.nombre
                                        : "—"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.nombre || "—"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.padre_producto_terminado
                                        ? item.padre_producto_terminado.nombre
                                        : "—"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.id || "—"}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
